import { useMount } from 'shared/hooks/useMount.ts'
import { useSwitcher } from 'shared/hooks/useSwitcher.ts'

// Actions
import { app } from '../../actions/app.js'
import { campaign } from '../../actions/campaign.js'
import { CampaignSteps } from '../../components/organisms/CampaingsStepCreate'
// Components
import { HomeTemplate } from '../../components/templates/homeTemplate'
import NotfoundPage from '../notfound/index.js'

export function CampaignsCreatePage() {
	const pageFound = useSwitcher(true)

	useMount(() => {
		app.changePage('/campaigns')
		app.changeActiveItem(1)
		campaign.getRecentCampaigns()
	})

	return pageFound.isOn ? (
		<HomeTemplate>
			<CampaignSteps onNotFound={pageFound.off} />
		</HomeTemplate>
	) : (
		<NotfoundPage />
	)
}
